import React, { useState, useEffect } from "react";
import Select from "@atlaskit/select";
import { useSelector, useDispatch } from "react-redux";
import { getAssetWorkspace, getAssetSchemas, setSelectedAssetSchema } from "../../../redux/actions/jiraAssetsActions";
import { getCredentials } from "../common/util/wizard.auth";
const AssetSchemaSelect = () => {
  const [schemas, setSchemas] = useState([]);
  const [selectedSchema, setSelectedSchema] = useState("");

  const assetSchemas = useSelector((state) => state.jiraAssets.assetSchemas);
  const selectedAssetSchema = useSelector((state) => state.jiraAssets.selectedAssetSchema);
  const workspace = useSelector((state) => state.jiraAssets.workspace);
  const creds = useSelector((state) => state.auth.creds);
  const currentData = useSelector((state) => state.wizard.currentData);

  const dispatch = useDispatch();

  useEffect(() => {
    setSelectedSchema(selectedAssetSchema);
  }, []);

  useEffect(() => {
    let credObject = getCredentials(currentData,creds)
    if(workspace === ""){
      dispatch(getAssetWorkspace(credObject))
    }else if(workspace !== "" && assetSchemas === null){
      dispatch(getAssetSchemas(workspace,credObject))
    }else if(assetSchemas !== null && assetSchemas !== schemas){
      applySchemaOptions(assetSchemas)
    }
  }, [workspace,assetSchemas]);


  const applySchemaOptions = (values) => {
    let opts = values.map((schema) => {
      return { value: schema.id, label: schema.name + " ("+schema.objectSchemaKey+")", name: schema.name };
    });

    opts.sort((a, b) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });
    setSchemas(opts);
  };

  const onSelectObjectSchema = (item) => {
    setSelectedSchema(item);
    dispatch(setSelectedAssetSchema(item));
  };

  return (
    <div className="schemaSelect">
      Asset Schemas
      <Select onChange={onSelectObjectSchema} options={schemas} value={selectedSchema} />
      <p>Choose the schema where to import assets</p>
    </div>
  );
};

export default AssetSchemaSelect;
